export default __webpack_public_path__ + "static/media/_MG_7896.543aeab2.jpg";